import { render } from "./metricBoxFacade.vue?vue&type=template&id=54b80188&scoped=true"
import script from "./metricBoxFacade.vue?vue&type=script&lang=js"
export * from "./metricBoxFacade.vue?vue&type=script&lang=js"

import "./metricBoxFacade.vue?vue&type=style&index=0&id=54b80188&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b80188"]])

export default __exports__